import React from 'react';
import { Row, Modal, ModalBody, ModalHeader} from 'reactstrap';
import LogInInstead from './elements/logInInstead';
import SignUpInstead from './elements/signUpInstead';
import SignupBase from './elements/signupBase';
import LogInBase from './elements/logInBase';

export default class SignInModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			emailOpen: false,
		};
	}
	toggleEmail = () => {
		this.setState({
			emailOpen: !this.state.emailOpen,
		});
	};

	render() {
		if(this.props.isSignUpOpen) {
			return (
				<div>
					<Modal autoFocus isOpen={this.props.isOpen} toggle={() => this.props.toggleModal} className="sign-up-modal" style={{ height: '200px' }}>
						<ModalHeader style={{ paddingBottom: '0' }} toggle={this.props.toggleModal} />
						<ModalBody style={{ paddingTop: '0', paddingBottom: '0' }}>
							<Row className="sign-up-wrapper">
								<SignupBase session={this.props.session} _csrf={this.props._csrf} toggle={this.props.toggleModal} />
								<LogInInstead toggleSignUpOpen={this.props.toggleSignUpOpen} />
							</Row>
						</ModalBody>
					</Modal>
				</div>
			);
		}
		return (
			<div>
				<Modal autoFocus isOpen={this.props.isOpen} toggle={() => this.props.toggleModal} className="sign-up-modal" style={{ height: '200px' }}>
					<ModalHeader style={{ paddingBottom: '0' }} toggle={this.props.toggleModal} />
					<ModalBody style={{ paddingTop: '0', paddingBottom: '0' }}>
						<Row className="sign-up-wrapper">
							<LogInBase session={this.props.session} _csrf={this.props._csrf} toggle={this.props.toggleModal} />
							<SignUpInstead toggleSignUpOpen={this.props.toggleSignUpOpen} />
						</Row>
					</ModalBody>
				</Modal>
			</div>
		);
	}
}
